import { Component, Optional } from '@angular/core';
import Swal from 'sweetalert2';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { HttpError } from 'src/app/shared/models/http-error.model';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-public-notification',
  templateUrl: './public-notification.component.html',
  styleUrls: ['./public-notification.component.scss']
})
export class PublicNotificationComponent {
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  message!: string;
  title!: string;
  loading = false;
  error: any = {};

  constructor(
    private notificationService: NotificationService,
    @Optional() protected dialogRef: NbDialogRef<any>
  ) {
  }

  onSubmit(): void {
    this.error = {};
    Swal.fire({
      title: 'آیا مطمئن هستید؟',
      text: 'این اعلان برای تمامی کاربران ارسال خواهد شد.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'بله',
      cancelButtonText: 'انصراف',
      confirmButtonColor: '#db2c66',
      cancelButtonColor: '#8f9bb3'
    }).then((result) => {
      this.loading = true;
      if (result.isConfirmed) {
        this.sendNotification();
      }
    })
  }

  sendNotification() {
    this.notificationService.createPublicNotification(this.title, this.message).subscribe(
      (Response) => {
        if (Response.status === 'OK') {
          this.Toast.fire({
            icon: 'success',
            title: 'اطلاعیه با موفقیت ارسال شد'
          });
        }
        this.loading = false;
        this.dialogRef.close();
      },
      (response: HttpError) => {
        if (response.status === 422) {
          this.error = response.validationError;
        } else {
          this.Toast.fire({
            icon: 'error',
            title: response.error
          });
        }
        this.loading = false;
      }
    );
  }
}
